interface CalibrationCandidateVerdict {
  id: number;
  recruiterVerdict: string;
  aiReviewScore: number;
}

interface RoundEndRevealProps {
  candidates: CalibrationCandidateVerdict[];
  onContinue: () => void;
}

/** US-379. AI thought "match" if the score clears the midpoint of the 0-50 scale. */
function aiThoughtMatch(score: number): boolean {
  return score >= 25;
}

export function RoundEndReveal({ candidates, onContinue }: RoundEndRevealProps) {
  const judged = candidates.filter((c) => c.recruiterVerdict !== 'unsure');
  const unsure = candidates.filter((c) => c.recruiterVerdict === 'unsure');
  const agreed = judged.filter((c) => (c.recruiterVerdict === 'match') === aiThoughtMatch(c.aiReviewScore));
  const disagreed = judged.filter((c) => (c.recruiterVerdict === 'match') !== aiThoughtMatch(c.aiReviewScore));

  return (
    <div className="p-6 space-y-4">
      <h2 className="text-lg font-semibold">Round complete</h2>
      <p className="text-2xl font-bold">
        {agreed.length}/{candidates.length} agreed with Arbie
      </p>
      <p className="text-sm text-gray-500">
        {unsure.length} unsure, {disagreed.length} disagreed
      </p>
      {disagreed.length > 0 && (
        <div className="space-y-2">
          <h3 className="font-medium">Notable disagreements</h3>
          {disagreed.slice(0, 3).map((c) => (
            <div key={c.id} className="text-sm border rounded p-2">
              Candidate #{c.id} — you said {c.recruiterVerdict === 'match' ? '👍' : '👎'}, Arbie scored {c.aiReviewScore}/50
            </div>
          ))}
        </div>
      )}
      <button
        className="px-4 py-2 bg-blue-600 text-white rounded"
        onClick={onContinue}
      >
        See what Arbie's changing →
      </button>
    </div>
  );
}
